export default function AboutMe() {
    return (
        <section id="AboutMe" className="about--section">
            <div className="hero--section--content--box about--section--box">
                <div className="hero--section--content">
                    <h1 className="skills--section--heading">
                        About Me
                    </h1>
                    <p className="hero--section-description">
                        Lorem 3feowbfjief
                    </p>
                </div>
            </div>
        </section>
    );
}